import {BarGroupBar as BarGroupBarType} from '@visx/shape/lib/types/barGroup';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {DataFrameRow} from 'data-frames/DataFrameTypes';

import {BarChartHoverInfo} from './BarChartTypes';

export const FADED_OPACITY = 0.25;

export type BarChartBarProps = Pick<BarGroupBarType<string>, 'color' | 'height' | 'width' | 'x' | 'y'> & {
  dataFrameRow: DataFrameRow;
  isFaded: boolean;
  onHover: (hoverInfo: Omit<BarChartHoverInfo, 'barGroupInfo'> | null) => void;
  stepWidth: number;
};

export default function BarChartBar({
  dataFrameRow,
  isFaded,
  onHover,
  stepWidth,
  ...barProperties
}: BarChartBarProps): JSX.Element | null {
  // Negative heights happen when we specify y-axis ranges where min is larger than max
  if (barProperties.height < 0) {
    return null;
  }

  return (
    <>
      <rect
        {...barProperties}
        width={stepWidth}
        fill="transparent"
        onMouseEnter={() => {
          onHover({
            dataFrameRow,
            barProperties,
          });
        }}
        onMouseLeave={() => {
          onHover(null);
        }}
      />
      <rect
        {...barProperties}
        className={css(styles.visibleRect)}
        fill={barProperties.color}
        opacity={isFaded ? FADED_OPACITY : 1}
        pointerEvents="none"
      />
    </>
  );
}

const styles = StyleSheet.create({
  visibleRect: {
    transition: 'opacity 0.2s',
  },
});
